var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.25C1.48122 0.25 0.25 1.48122 0.25 3V15C0.25 16.5188 1.48122 17.75 3 17.75H15C16.5188 17.75 17.75 16.5188 17.75 15V3C17.75 1.48122 16.5188 0.25 15 0.25H3ZM15 16.25C15.6904 16.25 16.25 15.6904 16.25 15V6.75H12.75V16.25H15ZM3 1.75C2.30964 1.75 1.75 2.30964 1.75 3V5.25H16.25V3C16.25 2.30964 15.6904 1.75 15 1.75H3ZM1.75 15C1.75 15.6904 2.30964 16.25 3 16.25H5.25V6.75H1.75V15ZM11.25 6.75V16.25H6.75V6.75H11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1ec77bd6500168261aeaefa54419f1be.svg";
export { ForwardRef as ReactComponent };